import { Injectable } from '@angular/core';
import {HttpClientService} from "./http-client.service";
import {HttpParams} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class FirmwareService {

  constructor(private http: HttpClientService) { }

  public getByIdProyecto(idProyecto: string) {
    let params = new HttpParams().set("idProyecto",idProyecto);
    return this.http.getWithParams('/firmware/getbyidproyecto', params);
  }

}
